import { RouteFactory } from "@app/routePaths";
import { AwardsMenu } from "@events-awards/utils/types";
import { TabItem } from "@hooks/useTabs";
import { JudgingPanelMember } from "@sba/utils/types";
import { sectionNavigationItems } from "@util/constant";

export const EVENTS_AWARDS_SBA_PATH = RouteFactory.section(
  "events-awards/singapore-business-awards"
);

export const EVENTS_AWARDS_SBA_SLOT = EVENTS_AWARDS_SBA_PATH.replace("/", "");

export const EVENTS_AWARDS_SBA_LABEL =
  sectionNavigationItems[EVENTS_AWARDS_SBA_SLOT]?.label;

export const SBA_FOOTER_MENU = [
  {
    label: "About",
    link: RouteFactory.sbaAboutPage,
  },
  {
    label: "Awards",
    link: RouteFactory.sbaAwardsPage,
  },
  {
    label: "Winners",
    link: RouteFactory.eventsAwardsWinners("singapore-business-awards"),
  },
  {
    label: "News",
    link: RouteFactory.eventsAwardsNews("singapore-business-awards"),
  },
  {
    label: "Gallery",
    link: RouteFactory.eventsAwardsGallery("singapore-business-awards"),
  },
  {
    label: "How to Nominate",
    link: RouteFactory.sbaNominatePage,
  },
  {
    label: "Contact Us",
    link: RouteFactory.sbaContactUsPage,
  },
];

export const SBA_NAVIGATION_ITEMS: AwardsMenu[] = [
  {
    text: "About",
    link: RouteFactory.sbaAboutPage,
    enabled: true,
  },
  {
    text: "Awards",
    link: RouteFactory.sbaAwardsPage,
    enabled: true,
  },
  {
    text: "Winners",
    link: RouteFactory.eventsAwardsWinners("singapore-business-awards"),
    enabled: true,
  },
  {
    text: "News",
    link: RouteFactory.eventsAwardsNews("singapore-business-awards"),
    enabled: true,
  },
  {
    text: "Gallery",
    link: RouteFactory.eventsAwardsGallery("singapore-business-awards"),
    enabled: true,
  },
  {
    text: "How to Nominate",
    link: RouteFactory.sbaNominatePage,
    enabled: true,
  },
];

export const AWARDS_TAB: TabItem[] = [
  {
    key: "businessman-of-the-year",
    label: "Businessman of the Year",
  },
  {
    key: "outstanding-chief-executive-of-the-year",
    label: "Outstanding Chief Executive of the Year",
  },
  {
    key: "the-enterprise-award",
    label: "The Enterprise Award",
  },
  {
    key: "outstanding-overseas-executive-of-the-year",
    label: "Outstanding Overseas Executive of the Year",
  },
  {
    key: "young-business-leader-of-the-year",
    label: "Young Business Leader of the Year",
  },
];

export const NOMINATIONS_TAB: TabItem[] = [
  {
    key: "nominationsTab",
    label: "Nominations",
  },
  {
    key: "eligibilityTab",
    label: "Eligibility",
  },
];

export const judgingPanel: JudgingPanelMember[] = [
  {
    name: "Mr Stephen Lee",
    title: "Former Chairman, Singapore Airlines",
    subtitle: "Chairman of the Judging Panel",
  },
  {
    name: "Ms Chen Huifen",
    title: "Executive Editor",
    subtitle: "The Business Times",
  },
  {
    name: "Mr Christopher Ong",
    title: "Senior Vice-President and Managing Director",
    subtitle: "DHL Express (Singapore) Pte Ltd",
  },
  {
    name: "Ms Jacqueline Poh",
    title: "Managing Director",
    subtitle: "Economic Development Board",
  },
  {
    name: "Ms Jeannie Lim",
    title: "Assistant Chief Executive Officer, Lifestyle & Consumer",
    subtitle: "Enterprise Singapore",
  },
  {
    name: "Ms Jennie Chua",
    title: "Chairman",
    subtitle: "Vanguard Healthcare",
  },
  {
    name: "Mr Lim Ming Yan",
    title: "Chairman",
    subtitle: "Singapore Business Federation",
  },
  {
    name: "Mr Loh Boon Chye",
    title: "Chief Executive Officer",
    subtitle: "SGX Group",
  },
  {
    name: "Professor Wee Chow Hou",
    title: "Emeritus Professor, Nanyang Technological University",
    subtitle: "Honorary Fellow, Singapore University of Social Sciences",
  },
  {
    name: "Mr Wong Wei Kong",
    title: "Editor-In-Chief, EMTM Group",
    subtitle: "SPH Media Trust",
  },
  {
    name: "Mr Yung Chiun Ooi",
    title: "Senior Vice President, Commercial",
    subtitle: "DHL Express Asia Pacific",
  },
];
